






















































































import { Component, Vue } from 'vue-property-decorator';
import router from '../router';
import users from '@/store/modules/users';
import addresses from '@/store/modules/addresses';
import controllers from '@/store/modules/controllers';
import CAddress from '@/components/CAddress.vue';
import { Address } from '@/store/models';
import store from '../store/store';

enum addrDlgMode {
    Add = 1,
    Edit,
}

@Component({
  components: {
    CAddress,
  },
})
export default class VAddresses extends Vue {
  private alerts: Array<{type: string, msg: string}> = [];
  private addrDlg: boolean = false;
  private mode: addrDlgMode = addrDlgMode.Add;
  private editAddr: Address = {} as Address;
  private inprogress: boolean = false;
  private rules = {
    required: (value: any) => !!value || 'Обязательное поле.',
    counter3: (value: any) => value && value.length >= 3 || 'Минимум 3 символа.',
  };

  get addresses() {
    return addresses.addresses;
  }

  get loggedIn() {
    return store. getters.loggedIn;
  }

  private beforeMount() {
    if (!store.getters.loggedIn) {
      router.replace('/login');
    }
  }

  private created() {
    this.inprogress = true;
    if (store.getters.loggedIn) {
      addresses.refreshAddresses(store.getters.user.id)
      // .then((addrs) => {
      //   if (addrs && addrs.length != 0) {}
      // })
      .catch((error: any) => {
        this.alerts.push({type: 'error', msg: 'Не удалось обновить список адресов. ' +
          'Ошибка на сервере или плохое соединение с интернетом.'});
        //  console.log(error);
      })
      .finally(() => {
        this.inprogress = false;
      });

      controllers.refreshControllers(store.getters.user.id)
        .catch((error: any) => {
          // console.error(error);
        });
    }
  }

  private editable(m: addrDlgMode): boolean {
    return (m === addrDlgMode.Edit);
  }

  private saveAddress() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    this.addrDlg = false;
    this.inprogress = true;
    addresses.saveOrAddAddress({uid: store.getters.user.id, addr: { ...this.editAddr }})
      .then((addr) => {
        if (addr != null) {
        this.alerts.push({type: 'success', msg: 'Изменения в адресе успешно сохранены.'});
        }
      })
      .catch((error: any) => {
        this.alerts.push({type: 'error', msg: 'Не удалось сохранить адрес.'});
        //   console.log(error);
      })
      .finally(() => {
        this.inprogress = false;
      });
  }

  private removeAddress() {
    this.addrDlg = false;
    const aid: number = this.editAddr.id;
    if (aid == null || aid === 0) {
      return;
    }

    this.inprogress = true;
    addresses.removeAddress({uid: store.getters.user.id, addrId: aid})
      .then((id) => {
        if (id != null) {
          this.alerts.push({type: 'success', msg: 'Адрес успешно удалён.'});
        }
      })
      .catch((error: any) => {
        this.alerts.push({type: 'error', msg: 'Не удалось удалить адрес.'});
      })
      .finally(() => {
        this.inprogress = false;
      });
  }

  private openAddAddress() {
    this.mode = addrDlgMode.Add;
    this.addrDlg = true;
    this.editAddr = {} as Address;
  }

  private openEditAddress(id: number) {
    this.mode = addrDlgMode.Edit;
    this.addrDlg = true;
    if (addresses.addresses) {
      addresses.addresses.forEach((el) => {
        if (el.id === id) {
          this.editAddr = { ...el };
        }
      });
    }
  }
}
